import IconDesktop from "./IconDesktop";
import ImageInv from "../../images/invoice.png";


function IconsRight({onClick}) {

    return (
        <div className='icons-right'>
            <IconDesktop image={ImageInv} p={"receipt"} onClick={() => onClick('invoicesList')} />
            <IconDesktop p={'SumF'} onClick={() => onClick('FilterFlights')} />
            <IconDesktop p={'Coupon'} onClick={() => onClick('coupon')} />
            <IconDesktop p={'Dockets'} onClick={() => onClick('filterDockets')} />
            <IconDesktop p={'customers'} onClick={() => onClick('customers')} />
            <IconDesktop onClick={() => onClick('')} />
            <IconDesktop onClick={() => onClick('')} />
        </div>
    )
}


export default IconsRight;